import { Link } from 'react-router-dom';
import { footerLinks } from '@/mocks/siteData';

export default function Footer() {
  return (
    <footer className="relative w-full bg-secondary-50">
      <div className="max-w-6xl mx-auto px-6 md:px-10 lg:px-16 py-16 md:py-20">
        <div className="bg-background-50 rounded-3xl p-8 md:p-12">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div className="sm:col-span-2 lg:col-span-1">
              <Link
                to="/"
                className="font-heading text-xl md:text-2xl font-bold text-foreground-950 tracking-tight whitespace-nowrap"
              >
                oopbuyspreadsheets
              </Link>
              <p className="text-sm text-foreground-500 mt-3 leading-relaxed max-w-xs">
                The ultimate oopbuy spreadsheet tracking and cost management system. Helping smart buyers organize, optimize, and scale their purchasing operations worldwide.
              </p>
            </div>

            <div>
              <h4 className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-4">
                Categories
              </h4>
              <ul className="space-y-2.5">
                {footerLinks.categories.map((link) => (
                  <li key={link.name}>
                    <a
                      href={link.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-4">
                Resources
              </h4>
              <ul className="space-y-2.5">
                {footerLinks.resources.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.url}
                      className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-4">
                Company
              </h4>
              <ul className="space-y-2.5">
                {footerLinks.company.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.url}
                      className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-200/70">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-foreground-400">
                &copy; {new Date().getFullYear()} oopbuyspreadsheets.xyz — All rights reserved.
              </p>
              <div className="flex items-center gap-4">
                <a
                  href="https://kaspreadsheet.com/"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-xs text-foreground-400 hover:text-foreground-700 transition-colors whitespace-nowrap"
                >
                  Privacy Policy
                </a>
                <span className="text-foreground-300 text-xs">|</span>
                <a
                  href="https://kaspreadsheet.com/"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-xs text-foreground-400 hover:text-foreground-700 transition-colors whitespace-nowrap"
                >
                  Terms
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}